import { useRef } from 'react'
import styled from 'styled-components'
import TwitterCard from '../BrowseComponents/TwitterCard'
import PostCard from '../BrowseComponents/PostCard'

const General = ({
    twitterPosts,
    posts,
    setHideHeader,
    headerState,
}: {
    twitterPosts: any
    posts: any
    setHideHeader: (value: boolean) => void
    headerState: boolean
}) => {
    const lastScrollTop = useRef(0)

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        const currentScrollTop = event.currentTarget.scrollTop
        if (currentScrollTop > lastScrollTop.current && !headerState) {
            setHideHeader(true)
        } else if (currentScrollTop < lastScrollTop.current && headerState) {
            setHideHeader(false)
        }
        lastScrollTop.current = currentScrollTop
    }

    return (
        <StyledPanelWrapper onScroll={handleScroll}>
            {twitterPosts?.map((twitter: any) => {
                return (
                    <TwitterCard
                        key={twitter.url}
                        user={twitter.user}
                        text={twitter.text}
                        media={twitter.media}
                        url={twitter.url}
                    />
                )
            })}
            {posts?.map((post: any) => {
                return <PostCard key={post.id} text={post.content} link={post.link} />
            })}
        </StyledPanelWrapper>
    )
}

export default General

const StyledPanelWrapper = styled.div`
    padding-top: 20px;

    display: flex;
    flex-direction: column;
    align-items: center;

    gap: 20px;

    overflow: auto;

    height: 100%;
    width: 100%;
`
